import ajax from "./request.js";

let bool = process.env.NODE_ENV === "production";
const baseUrl = bool
? `https://${window.location.host}/api/cloud`
: "/api/cloud";
const href = bool
  ? `https://${window.location.host}/api/cloud/project`
  : "/api/cloud/project";

const href1 = bool
  ? `https://${window.location.host}/api/cloud/projectType`
  : "/api/cloud/projectType";

const href2 = bool
  ? `https://${window.location.host}/api/cloud/projectPublic`
  : "/api/cloud/projectPublic";

function getProjectsList(data) {
  return ajax(`${href}/list`, {
    method: "POST",
    data,
  });
}

function appOrUpdateProject(data) {
  return ajax(`${href}/addOrUpdate`, {
    method: "POST",
    data,
  });
}

function getEcologyList() {
  return ajax(`${baseUrl}/ecology/list`, {
    method: "POST"
  });
}

function getListType(data) {
  return ajax(`${baseUrl}/custom/listByType`, {
    method: "POST",
    data
  });
}

function getProjectInfo(data) {
  return ajax(`${data.isCommonTemplate ? href2 : href}/findByProjectId`, {
    method: "POST",
    data: {
      id: data.id,
      // 仅网页编辑器传 lazy_load；安卓不传该字段，后端返回全量 panel_data
      lazy_load: data.lazyLoad !== false && !data.isCommonTemplate,
    },
  });
}

/** 按页加载画布组件数组。body: { id, pageId } */
function findProjectPage(data) {
  return ajax(`${href}/findPage`, {
    method: "POST",
    data: {
      id: data.id,
      pageId: data.pageId,
    },
  });
}

/** 保存单页画布。body: { id, pageId, pageData, sortNo? } */
function saveProjectPage(data) {
  return ajax(`${href}/savePage`, {
    method: "POST",
    data,
  });
}

function saveInteractionPackage(data) {
  return ajax(`${href}/saveInteractionPackage`, {
    method: "POST",
    data,
  });
}

function getProjectCache(key) {
  return ajax(`${baseUrl}/temp/get`, {
    method: "POST",
    data: {
      key: key,
    }
  });
}

function setProjectCache(data) {
  return ajax(`${baseUrl}/temp/set`, {
    method: "POST",
    data: data
  });
}

function removeProjectCache(key) {
  return ajax(`${baseUrl}/temp/remove`, {
    method: "POST",
    data: {
      key: key
    }
  });
}
function deleteProjects(data) {
  return ajax(`${href}/deleteByIds`, {
    method: "POST",
    data,
  });
}

function getProjectLevelsList(data) {
  return ajax(`${href1}/list`, {
    method: "POST",
    data,
  });
}
function updateProjectImg(data) {
  return ajax(`${href}/updateImg`, {
    method: "POST",
    data,
  });
}

function copyProjects(data) {
  return ajax(`${href}/copy`, {
    method: "POST",
    data,
  });
}

function exportByProjectId(data) {
  return ajax(`${href}/exportByProjectId`, {
    method: "POST",
    data,
  });
}

function downloadProject(data) {
  return ajax(`${href}/download`, {
    method: "POST",
    data,
  });
}
function moveProject(data) {
  return ajax(`${href}/moveProject`, {
    method: "POST",
    data,
  });
}

function queryTransferLogs(data) {
  return ajax(`${href}/transferLogs`, {
    method: "POST",
    data,
  });
}

function reassignTransfer(data) {
  return ajax(`${href}/reassignTransfer`, {
    method: "POST",
    data,
  });
}

function importProbePanel(data) {
  return ajax(`${href}/importProbePanel`, {
    method: "POST",
    data,
  });
}

export default {
  getProjectsList,
  getProjectLevelsList,
  appOrUpdateProject,
  deleteProjects,
  getProjectInfo,
  findProjectPage,
  saveProjectPage,
  saveInteractionPackage,
  updateProjectImg,
  copyProjects,
  exportByProjectId,
  downloadProject,
  moveProject,
  queryTransferLogs,
  reassignTransfer,
  importProbePanel,
  getEcologyList,
  getListType,
  getProjectCache,
  setProjectCache,
  removeProjectCache
};
